import Swal from "sweetalert2";
import "./shareDialog.web.css";

interface ShareDialogOptions {
  onCopyLink: () => void;
  onShareVia: () => void;
  onShareInFeed?: () => void;
}

export const showShareDialog = async ({
  onCopyLink,
  onShareVia,
  onShareInFeed,
}: ShareDialogOptions): Promise<void> => {
  try {
    const result = await Swal.fire({
      title: "Share",
      backdrop: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: Boolean(onShareInFeed),
      confirmButtonText: "Copy Link",
      denyButtonText: "Share via...",
      cancelButtonText: "Share in Feed",
      customClass: {
        popup: "share-dialog-popup",
        title: "share-dialog-title",
        confirmButton: "share-dialog-copy-btn",
        denyButton: "share-dialog-share-btn",
        cancelButton: "share-dialog-feed-btn",
      },
      buttonsStyling: false,
    });

    if (result.isConfirmed) {
      onCopyLink();
    } else if (result.isDenied) {
      onShareVia();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      onShareInFeed?.();
    }
  } catch (error) {
    console.error("::showShareDialog - error", error);
  }
};
